import React, { useEffect, useState } from "react";

const PercentFormat = ({ value }) => {
  const [p, setP] = useState(null);
  const [style, setStyle] = useState({});
  useEffect(() => {
    if (value == 0) {
      setStyle({ color: "darkred" });
    } else if (0 < value && value < 100) {
      setStyle({ color: "darkgoldenrod" });
    } else if (value == 100) {
      setStyle({ color: "green" });
    }
    setP(value);
  }, [value]);

  return (
    <React.Fragment>
      <span style={style}>
        <b>{p?.toFixed(2)}%</b>
      </span>
    </React.Fragment>
  );
};

export default PercentFormat;
